import axios from 'axios'

// URL base das requests
const baseURL = process.env.REACT_APP_API
// const baseURL = 'https://finsol.assina.devrbm.top/api/' // DEV DNS
// const baseURL = 'http://localhost:3333/api/' // DEV LOCAL
// const baseURL = 'https://assina.finsol.aplicativo.digital/api/' // PROD
/** Instancia API */ 
var api = axios.create({
    baseURL
})

/** INTERCEPTORS DA REQUEST */
api.interceptors.request.use(async config => {
    const token = localStorage.getItem('token')
    if( token ) config.headers.authorization = token
    config.headers['Access-Control-Allow-Origin'] = "*"
    return config
})

// api.interceptors.response.use(async response => {
//     console.log('response',response)

//     return response
// })
export default api
